enum NOTIFICATION_CHANNEL_ENUM {
  USER_NOTIFICATION = 'user-notification.',
}

enum NOTIFICATION_EVENT_ENUM {
  NOTIFY_USER = '.NotifyUser',
}

export { NOTIFICATION_CHANNEL_ENUM, NOTIFICATION_EVENT_ENUM }
